import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, useAttrs } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppCard',
  props: {
    unstyled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const attrs = useAttrs();

const cardClass = computed(() => [
  props.unstyled ? null : "app__card",
  attrs.class as any,
]);
const cardStyle = computed(() => attrs.style as any);

const cardAttrs = computed(() => {
  const { class: _class, style: _style, ...rest } = attrs;
  return rest;
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, _mergeProps({
    class: cardClass.value,
    elevation: "0",
    style: cardStyle.value
  }, cardAttrs.value), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class", "style"]))
}
}

})